import { ChangeDetectionStrategy, Component, effect, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';
import { CookieConsentService } from '../../services/cookie-consent.service';
import { Button } from './components/button/button';
import { Switch } from './components/switch/switch';

@Component({
  selector: 'app-cookie-banner',
  imports: [Button, RouterLink, Switch, TranslatePipe],
  templateUrl: './cookie-banner.html',
  styleUrl: './cookie-banner.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieBanner {
  readonly #cookieConsent = inject(CookieConsentService);

  protected readonly analyticsEnabled = signal<boolean>(this.#cookieConsent.analyticsAccepted());

  protected readonly shouldShowBanner = this.#cookieConsent.shouldShowBanner;
  protected readonly hasDecision = this.#cookieConsent.hasDecision;

  constructor() {
    effect(() => {
      this.analyticsEnabled.set(this.#cookieConsent.analyticsAccepted());
    });
  }

  protected acceptAll(): void {
    this.#cookieConsent.acceptAll();
  }

  protected acceptEssentialOnly(): void {
    this.#cookieConsent.acceptEssentialOnly();
  }

  protected savePreferences(): void {
    this.#cookieConsent.savePreferences({
      analytics: this.analyticsEnabled(),
    });
  }

  protected onAnalyticsChange(value: boolean): void {
    this.analyticsEnabled.set(value);
  }
}
